import {
  AfterViewInit,
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  Input, NgZone,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {visavailChart} from '../../vendors/visavail/visavial';
import * as d3 from '../../vendors/d3/d3.min.js';
import * as moment from 'moment';
import {BlockService} from '../../service/BlockService';
import {Action} from '../../model/action';
import {MatCheckbox, MatDatepicker, MatDatepickerInputEvent, MatDialog} from '@angular/material';
import {DialogComponent} from '../dialog/dialog.component';
import {ActivatedRoute, Router} from '@angular/router';
import {EmitterService} from '../../service/EmitterService';
import {environment} from '../../../environments/environment';
import {ConfirmatonDialogComponent} from './confirmaton-dialog/confirmaton-dialog.component';
import {_} from 'underscore';
import {AppComponent} from '../../app.component';
import {UserService} from '../../service/UserService';
import {BreakService} from '../../service/break.service';
import {AlertService} from '../../service/alert.service';
import {TimeZoneService} from '../../service/TimeZoneService';
import {ReclamationDialogComponent} from './reclamation-dialog/reclamation-dialog.component';
import {RoleService} from '../../service/RoleService';
import {
  DATE_BLOCK_BASIC, DATE_BLOCK_FRANCE,
  DATE_DEFAULT_FORMAT,
  DATE_TIME_FORMAT,
  DATE_TIMEZONE_FORMAT, JUSTIFICATION_TIME_INSERT
} from '../../model/commons/DateConstants';
import {ROLE_COORDI_FORMATION_MYSHIFT2, ROLE_FORMATEUR_MYSHIFT2} from '../../model/commons/RoleConstants';
import {LoggerService} from '../../service/LoggerService';
import {MessageService} from '../../service/message.service';
import {race} from 'rxjs/observable/race';
import {timer} from 'rxjs/observable/timer';
import {
  $DURATION,
  IS_PLANNED_PAUSE,
  IS_REALISE_NON_DECLARATIVE,
  MAURICE_MATRICULE_TEST,
  MAX_WAIT_TIME_IN_MS,
  PLANNED_PAUSE_DURATION,
  TIMER_INDICATOR
} from '../../helpers/GlobalConstants';
import {isNumber} from 'util';
import {ObjectNotificationService} from '../../service/obj-notification.service';
import {InsertDialogComponent} from '../Insert-dialog/insert-dialog.component';
import {InsertRealiseDialogComponent} from '../Insert-realise-dialog/insert-realise-dialog.component';
import {UpdateRealiseDialogComponent} from '../update-realise-dialog/update-realise-dialog.component';
import {TranslateService} from "@ngx-translate/core";
import {EnvService} from "../../service/env.service";
import {BlockVO} from "../../model/BlockVO";
import {BLOCKS_EVENT} from "../../vendors/visavail/ResizeSplitBlock";
import {MotifService} from "../../service/MotifService";
import {MutualisationDialogComponent} from "./mutualisation-dialog/mutualisation-dialog.component";
import {TadInHoursFilter} from '../../model/tadInHoursFilter';
import {ApiService} from '../../modules/injection/api.service';
import {TadInHoursVO} from '../../model/tadInHoursVO';
import {AuthService} from '../../auth/services/auth.service';
import {ResponseVerro} from '../../model/ResponseVerro';
import {ModalCommentComponent} from '../../modules/injection/modal-comment/modal-comment.component';

@Component({
  selector: 'app-block-temps',
  templateUrl: './block-temps.component.html',
  styleUrls: ['./block-temps.component.css'],
  encapsulation: ViewEncapsulation.None

})
export class BlockTempsComponent implements OnInit, AfterViewInit {
  renderData: BlockVO;
  /**
   * Condittion Pour active ou desactive button valider
   *
   *   - Dépassement : il faut traiter le dépassement apers valider les incos
   *
   *   - No Planned  and No FulFilled: désactiver le button
   *
   *   - si les incos déja valide: désactiver le button
   *
   *   -
   */

  public set_data_block: any;
  isShowBtnUpdateRealise : boolean = true;
  static readonly MIN_BLOCK_LENGTH = 300;
  static readonly MIN_BLOCK_LENGTH_FR = 60;
  ALLOWED_TO_DIALOG = [
    'INCOHERENCE_CREATED_INSERVICE',
    'INCOHERENCE_CREATED_OFFSERVICE',
    'INCOHERENCE_VALIDATED_INSERVICE',
    'INCOHERENCE_VALIDATED_OFFSERVICE',
    'INCOHERENCE_CREATED_FORMATIONCONTINUE',
    'INCOHERENCE_VALIDATED_FORMATIONCONTINUE',
  ];
  public conditionValidationButton = {
    isLoadTad: true,
    isTAD: false,
    isNow: true,
    isPLanned: false,
    isFULFILLED_INCOHERENCE: false,
    isValidateFULFILLED_INCOHERENCE: false,
    validationDate: null,
    hasBlockFULFILLED_SYSTEM: false,
    isValidateBreaks: false,
    isUpdateBreaks: false,
    enableVerroButton: false,
    isShowSeuilPlus: this.blockservice.isShowSeuil
  };
  detailsCollaborator : any;
  public chart = null;
  public validatedBy = {username: '', firstName: '', lastName: ''};
  public _isFormation = false;
  public prevuDisabled = true;
  public isValid = false;
  public _period = {start: null, end: null};
  public _regLoading = false;
  public validerDisabled = true;
  public minDate: any;
  private incoherences: any;
  public maxDate: any;
  public data: any = {};
  public commentFiche: any = {};
  public newuser: any;
  blockNavigation = false;
  private reclamButtonEnabled = false;
  public valueDate: any;
  public zoomActive = environment.debug.zoom;
  public ButtonValid = false;
  public paramValidation = 4;
  public totalPlanned = 0;
  public totalBreak = 0;
  public totalProduction = 0;
  public actions = true;
  public durationBreak = 0;
  dateFiche: any;
  public Display = this.initDisplay();
  blockTempsTransalte: any = {};


  private initDisplay() {
    return {
      row: ['Prévu', 'Réalisé', 'Réalisé validé'],
      breaks: true,
      header: true,
      paginator: true,
      buttons: {
        valider: true,
        claim: false
      },
      styles: {
        margin: {top: 70, right: 40, bottom: 20, left: 100},
        height: '235px',
        width: 940
      },
      dialog: true
    };
  }

  public calimActive = this.Display.buttons.claim;
  public calimDisabled = false;

  date = null;
  oldWidth = 0;
  loading = true;
  _users: Array<any>;
  displayAddSystemBlock = false;
  _dataSource: any;
  _isNow = true;
  _enableVerro = false;
  alreadyUnlocked: boolean = false;
   hasSeuil = false;
  private breakOverflows: any[] = [];
  @ViewChild(MatDatepicker) picker: MatDatepicker<Date>;
  @Output() condition = new EventEmitter();
  alreadyExists: boolean;
  isShowComment: boolean = true;
  existRequestUnlocking: boolean;
  _timeInsertion: any;


  @Output()
  blockDate = new EventEmitter();

  @Output()
  onLoad = new EventEmitter();
  incos : any[] = [];


  @Input()
  public set period(period) {
    this._period = period;
    this.route.queryParamMap.source.subscribe(res => {
      if (res.dateFiche) {
        console.log('dateFiche', res.dateFiche);
        this.dateFiche = res.dateFiche;
        this.setPeriod(this.newuser, this.dateFiche);
      } else {
        this.setPeriod(this.newuser);
      }
    });
  }

  @Input()
  public set config(value) {
    this.Display = value;
    this.calimActive = this.Display.buttons.claim;
  }


  @Input()
  public set timeInsertion(timeInsertion) {
    this._timeInsertion = timeInsertion;
  }


  @Input()
  public set dataSource(value) {
    this._dataSource = value;
    if (value.length > 0) {
      const user = value[0].user.username;
      this.newuser = user;
      this._users = [value[0].user];
      this.date = moment(value[0].start).format(DATE_DEFAULT_FORMAT);
      this.data = value;
      this.loading = false;
      this.onLoad && this.onLoad.emit(false);
    }
  }

  @Input('users')
  public set users(value) {
    console.log('========================>', value)
    this._users = [{
      username: value.username,
      firstName: value.firstName,
      lastName: value.lastName,
      date: moment().toDate(),
      _username: value.username,
      periods: value.periods,
      villeLabel: value.villeLabel
    }];
    if(value.defaultDate) this.dateFiche = value.defaultDate
    this._users.forEach((user, i) => {
      this.newuser = user.username;
      this.setPeriod(user.username, this.dateFiche ? this.dateFiche : null);
    });
  }

  width = 0;
  public paginationButtons = true;
  public hasAvailable = true;

  allTadHours: TadInHoursVO[] = [];

  constructor(private _changeDetector: ChangeDetectorRef,
              public translate: TranslateService,
              public env: EnvService,
              private serviceApi: ApiService,
              private alertService: AlertService,
              public motifService: MotifService,
              public blockservice: BlockService,
              private breakService: BreakService,
              private emit: EmitterService,
              public dialog: MatDialog,
              public app: AppComponent,
              public router: Router,
              private userService: UserService,
              private auth: AuthService,
              private refChange: ChangeDetectorRef,
              private roleService: RoleService,
              private LOG: LoggerService,
              private route: ActivatedRoute,
              private tzService: TimeZoneService,
              private messageService: MessageService,
              private elRef: ElementRef,
              private objNotificationService: ObjectNotificationService,
              private ngZone: NgZone) {
    blockservice.getParamValidation((param) => {
      this.paramValidation = param;
    });

  }

  initCondition() {
    this.detailsCollaborator = null;
    this._enableVerro = false;
    this.isShowComment = false;
    this.commentFiche = {};
    this.alreadyUnlocked = false;
    this.conditionValidationButton = {
      isLoadTad: true,
      isTAD: false,
      isNow: true,
      isPLanned: false,
      isFULFILLED_INCOHERENCE: false,
      isValidateFULFILLED_INCOHERENCE: false,
      validationDate: null,
      hasBlockFULFILLED_SYSTEM: false,
      isValidateBreaks: false,
      isUpdateBreaks: false,
      enableVerroButton: false,
      isShowSeuilPlus: this.blockservice.isShowSeuil
    };
  }

  setPeriod(user, forcedDate?) {
    this.newuser = user;
    this.minDate = this._period && moment((this._period.start ? this._period.start : '2000-01-01')).toDate();
    if (this._period) {
      if (!this._period.end) {
        if (forcedDate) {
          console.log('forcedDate', forcedDate);
          this.GoToDate('goto', user, moment(forcedDate).format(DATE_DEFAULT_FORMAT));
        }
        else {
          this.GoToDate('now', user);
        }
        this.maxDate = moment().toDate();
      } else {
        if (typeof  user !== 'undefined') {
          if (forcedDate) {
            console.log('forcedDate', forcedDate);
            this.GoToDate('goto', user, moment(forcedDate).format(DATE_DEFAULT_FORMAT));
          } else {
            this.toDate(this._period.end);
          }
          this.newuser = user;
          this.maxDate = moment(this._period.end).toDate();
        }
      }
      this.valueDate = forcedDate ? moment(forcedDate, DATE_TIMEZONE_FORMAT).toDate() : moment(this.maxDate, DATE_TIMEZONE_FORMAT).toDate();
    }
  }

  checkReopenButton() {
    const d1 = this.blockservice.startPaie;
    const d2 = this.blockservice.endPaie;
    const nbMois = this.blockservice.nbMois;
    this.alreadyExists = this.blockservice.alreadyExists;
    this.existRequestUnlocking = this.blockservice.existRequestUnlocking;
    const displayReopenButton = this.blockservice.displayReopenButton;
    const dates = this.tzService.getReopenFichePeriod(d1, d2, nbMois,moment(this.blockservice.currentDate),this.userService.getUserCountry());
    this.LOG.info(`Fiche is open between ${dates[0]} and ${dates[1]}`);
    if (!this.alreadyExists && displayReopenButton && moment(this.blockservice.currentDate).isSameOrBefore(moment(dates[1])) && moment(this.blockservice.currentDate).isSameOrAfter(moment(dates[0]))) {
      return true;
    }
    return false;
  }

  // Check that TL type is PROD or Hors PROD
  checkTlIsProdAndIsNotCurrentUser(){
    return this.auth.checkTlIsProd() && this.notCurrentUser();
  }

  notCurrentUser(){
    return this._users[0].username !== this.userService.getCurrentUser('userName');
  }
  getValidation() {
    const boolean = true;
    const temp1 = this.conditionValidationButton;
    if (!temp1.isNow) {
      return (temp1.isValidateFULFILLED_INCOHERENCE ? boolean : (
        temp1.isFULFILLED_INCOHERENCE ? !boolean : boolean
      ));
    } else {
      return boolean;
    }
  }

  ngOnInit() {

    this.emit.refreshBlock().subscribe((data) => {
      if (data == this._users[0].username) {
        this.GoToDate('refresh', this.newuser);
      }
    });
    this.emit.refreshDataWithDate().subscribe((date: any) => {
      let _period = Object.assign({}, this._period);
      date = moment(date).format(DATE_DEFAULT_FORMAT);
      let d = date;
      _period.end = (_period.end != null ? _period.end : moment().format(DATE_DEFAULT_FORMAT));
      const is = this.isBetween(date, _period.start, _period.end);
      d = (is ? date : _period.end);
      this.toDate(d);
    });


    this.translate.onLangChange.subscribe(() => {
      const translate = this.translate.translations[this.translate.currentLang];
      this.blockTempsTransalte = translate.BLOCK_TEMPS
      this.refresh()
    })
  }

  private async checkVerro(callback) {

    // @RG: Check verro of uo

    if(await this.blockservice.checkVerroOfUo(this._users[0].date)) return;

    const collaborator = this.userService.getUser();

    if (collaborator.countryCode == "CO") return callback();

    const avatar: string = collaborator.userName;
    const countryCode: string = collaborator.countryCode;
    const job: string = collaborator.job;
    const currentOps = environment.verroFiche.onlyOps;
    const isMaurice = avatar && avatar.startsWith('R');
    const isPortugal = avatar && avatar.startsWith('P');
    const isFrance = countryCode && countryCode === 'FR';
    const isTunis = countryCode && countryCode === 'TN';
    const isQMTL = job && environment.QMTLJob.includes(job);
    //const isInsourcing = avatar && environment.exceptionUserInjectRealise.includes(avatar);
    const isInsourcing = false;
    const currentDateIsAfterExceptionDate = moment(this._users[0].date).isSameOrAfter(environment.verroFiche.exceptionDate);
    const currentDateIsAfterMauriceExceptionDate = moment(this._users[0].date).isSameOrAfter(environment.verroFiche.exceptionDateOfMaurice);
    const currentDateIsAfterQMTLExceptionDate = moment(this._users[0].date).isSameOrAfter(environment.verroFiche.exceptionDateQMTL);
    const currentDateIsAfterFranceExceptionDate = moment(this._users[0].date).isSameOrAfter(environment.verroFiche.exceptionDateFrance);
    const currentDateIsAfterTunisExceptionDate = moment(this._users[0].date).isSameOrAfter(environment.verroFiche.exceptionDateTunis);
    const currentDateIsAfterPortugalExceptionDate = moment(this._users[0].date).isSameOrAfter(environment.verroFiche.exceptionDatePortugal);
    const currentDateIsAfterInsourcingExceptionDate = moment(this._users[0].date).isSameOrAfter(environment.verroFiche.exceptionDateInsourcing);
    const currentDateIsAfterGeneralExceptionDate = moment(this._users[0].date).isSameOrAfter(environment.verroFiche.generalExceptionDate);
    const currentBUMs = environment.verroFiche.onlyBUMs;
    const {userName} = JSON.parse(localStorage.getItem(environment.oauth.remoteUser));
    const {limitJours, joursValidationMax, moreForHierarchy} = environment.verroFiche;
    const {authorities} = JSON.parse(localStorage.getItem(environment.oauth.remoteUser));
    const role = authorities.filter(e => e.clientId == 'myshift2').map(e => e.authority);
    let _check = false;
    let _checkOPS = false;
    const _checkMaxValidation = (moment(new Date()).diff(this._users[0].date, 'days') >= joursValidationMax);
    const dataVerro = {
      usernameCC: this._users[0].username,
      date: moment(this._users[0].date).format(DATE_DEFAULT_FORMAT),
      limitJours,
      joursValidationMax,
      userName
    };
    const dataVerroOps = {
      usernameCC: this._users[0].username,
      date: moment(this._users[0].date).format(DATE_DEFAULT_FORMAT),
      limitJours,
      joursValidationMax,
      moreForHierarchy
    };
    const dataVerroBUM = {
      usernameCC: this._users[0].username,
      date: moment(this._users[0].date).format(DATE_DEFAULT_FORMAT),
      limitJours,
      joursValidationMax,
      moreForHierarchy
    };

    role.forEach((e, i) => {
      if (environment.verroFiche.permissionsUser.indexOf(e) === 0) {
        _check = true;
      }
      if (environment.verroFiche.permissionsUser.indexOf(e) === 1) {
        _checkOPS = true;
      }

    });
    // TL Verro Conditions
    const isTLWithinList = _check && _checkMaxValidation && environment.verroFiche.exceptionUsers.indexOf(userName) > -1 && currentDateIsAfterExceptionDate;
    const isMauriceTL = _check && _checkMaxValidation && isMaurice && currentDateIsAfterMauriceExceptionDate;
    const isFranceTL = _check && _checkMaxValidation && isFrance && currentDateIsAfterFranceExceptionDate;
    const isTunisTL = _check && _checkMaxValidation && isTunis && currentDateIsAfterTunisExceptionDate;
    const isPortugalTL = _check && _checkMaxValidation && isPortugal && currentDateIsAfterPortugalExceptionDate;
    const isQMTeamLead = _check && _checkMaxValidation && isQMTL && currentDateIsAfterQMTLExceptionDate;
    const isInsourcingTL = _check && _checkMaxValidation && isInsourcing && currentDateIsAfterInsourcingExceptionDate;
    const isOtherGeneralTL = _check && _checkMaxValidation && !(environment.verroFiche.exceptionUsers.indexOf(userName) > -1) && !isMaurice && !isFrance && !isPortugal && !isQMTL && !isInsourcing && currentDateIsAfterGeneralExceptionDate;
    const generalLock = _check && _checkMaxValidation && currentDateIsAfterGeneralExceptionDate;
    // OPS Verro Conditions
    const isOPSWithinList = _checkOPS && _checkMaxValidation && currentOps.indexOf(avatar) > -1 && currentDateIsAfterExceptionDate;
    const isMauriceOPS = _checkOPS && _checkMaxValidation && isMaurice && currentDateIsAfterMauriceExceptionDate;
    const isFranceOPS = _checkOPS && _checkMaxValidation && isFrance && currentDateIsAfterFranceExceptionDate;
    const isTunisOPS = _checkOPS && _checkMaxValidation && isTunis && currentDateIsAfterTunisExceptionDate;
    const isPortugalOPS = _checkOPS && _checkMaxValidation && isPortugal && currentDateIsAfterPortugalExceptionDate;
    const isQMTLOPS = _checkOPS && _checkMaxValidation && isQMTL && currentDateIsAfterQMTLExceptionDate;
    const isInsourcingOPS = _checkOPS && _checkMaxValidation && isInsourcing && currentDateIsAfterInsourcingExceptionDate;
    const isOtherGeneralOPS = _checkOPS && _checkMaxValidation && !isMaurice && !isFrance && !isPortugal && !isQMTL && !isInsourcing && !(currentOps.indexOf(avatar) > -1) && currentDateIsAfterGeneralExceptionDate;
    // BUM Verro Conditions
    const isBUmWithinList = this.roleService.isBUM && _checkMaxValidation && currentBUMs.indexOf(avatar) > -1 && currentDateIsAfterExceptionDate;
    const isMauriceBUM = this.roleService.isBUM && _checkMaxValidation && isMaurice && currentDateIsAfterMauriceExceptionDate;
    const isFranceBUM = this.roleService.isBUM && _checkMaxValidation && isFrance && currentDateIsAfterFranceExceptionDate;
    const isTunisBUM = this.roleService.isBUM && _checkMaxValidation && isTunis && currentDateIsAfterTunisExceptionDate;
    const isPortugalBUM = this.roleService.isBUM && _checkMaxValidation && isPortugal && currentDateIsAfterPortugalExceptionDate;
    const isQMTLBUM = this.roleService.isBUM && _checkMaxValidation && isQMTL && currentDateIsAfterQMTLExceptionDate;
    const isInsourcingBUM = this.roleService.isBUM && _checkMaxValidation && isInsourcing && currentDateIsAfterInsourcingExceptionDate;
    const isOtherGeneralBUM = !(currentBUMs.indexOf(avatar) > -1) && _checkMaxValidation && !isMaurice && !isFrance && !isPortugal && !isQMTL && !isInsourcing && this.roleService.isBUM && currentDateIsAfterGeneralExceptionDate;
    const roleFormateur = (role.indexOf(ROLE_FORMATEUR_MYSHIFT2) > -1) || (role.indexOf(ROLE_COORDI_FORMATION_MYSHIFT2) > -1);
    if (!roleFormateur) {
      if (isTLWithinList || isMauriceTL || isFranceTL || isTunisTL || isPortugalTL || isQMTeamLead || isInsourcingTL || isOtherGeneralTL) {
        // Verro TL
        this.blockservice.verro(dataVerro).subscribe((responseVerro: ResponseVerro) => {
            this._isNow = responseVerro.locked;
            this.alreadyUnlocked = responseVerro.alreadyUnlocked;
            this._enableVerro = responseVerro.locked;
            this.conditionValidationButton.isNow = responseVerro.locked;
            this.conditionValidationButton.enableVerroButton = responseVerro.locked;
          },
          error => {
          },
          () => {
            callback();
          });
      } else if (isOPSWithinList || isMauriceOPS || isTunisOPS || isFranceOPS || isPortugalOPS || isQMTLOPS || isInsourcingOPS || isOtherGeneralOPS) {
        // Verro OPS
        this.blockservice.verro(dataVerroOps).subscribe((responseVerro: ResponseVerro) => {
            this._isNow = responseVerro.locked;
            this.alreadyUnlocked = responseVerro.alreadyUnlocked;
            this._enableVerro = responseVerro.locked;
            this.conditionValidationButton.isNow = responseVerro.locked;
            this.conditionValidationButton.enableVerroButton = responseVerro.locked;
          },
          error => {
          },
          () => {
            callback();
          });
      } else if (isBUmWithinList || isMauriceBUM || isTunisBUM || isFranceBUM || isPortugalBUM || isQMTLBUM || isInsourcingBUM || isOtherGeneralBUM) {
        // Verro BUM
        this.blockservice.verro(dataVerroBUM).subscribe((responseVerro: ResponseVerro) => {
            this._isNow = responseVerro.locked;
            this.alreadyUnlocked = responseVerro.alreadyUnlocked;
            this._enableVerro = responseVerro.locked;
            this.conditionValidationButton.isNow = responseVerro.locked;
            this.conditionValidationButton.enableVerroButton = responseVerro.locked;
          },
          error => {
          },
          () => {
            callback();
          });
      } else {
        callback();
      }
    } else {
      callback();
    }
  }

  async toDate(date, user?) {
    if (moment(date).format(DATE_DEFAULT_FORMAT) == moment().format(DATE_DEFAULT_FORMAT)) {
      const d = await this.blockservice.getDateFromHeader('date');
      date = moment(d).format(DATE_DEFAULT_FORMAT);
    }
    this.GoToDate('goto', this.newuser, date);
  }

  ngAfterViewInit() {
    const el1: any = document.querySelector('.mytimesheet, .trainingContainer, .timesheetContainer, .timeInsert');
    const el2: any = document.querySelector('.timesheet-area');
    const el3: any = document.querySelector('.reclamation-block');
    const el4: any = document.querySelector('app-block-temps');
    switch (this.router.url) {
      case '/reclamation':
        this.width = (el3.offsetWidth - 220);
        break;
      case '/mytimesheet':
        this.width = (el1.offsetWidth - 155);
        break;
      case '/timeInsert':
        this.width = (el1.offsetWidth - 200);
        break;
      case '/timesheet':
        this.width = (el1.offsetWidth - 155);
        break;
      case '/searchtimesheet':
        this.width = (el1.offsetWidth - 155);
        break;
      case '/training':
        this.width = (el1.offsetWidth - 155);
        break;
      case '/checksum':
        this.width = (el4.offsetWidth - 125);
        break;
      default :
        this.width = (el1.offsetWidth - 200);
        break;
    }
    this.oldWidth = this.width;
    if (this.date !== null) {
      this.setBlock(this.blockservice.formatBlock(this.newuser, this.date, this.data, true));
    }


  }

  setBlock(data: BlockVO, version?) {
    const collaborator = this.userService.getUser();

    const countryCode: string = collaborator.countryCode;

    const translate = this.translate.translations[this.translate.currentLang];
    this.blockTempsTransalte = translate.BLOCK_TEMPS;
    this.set_data_block = data;
    console.log("set_data_block :", this.set_data_block)
    this.Display = this.initDisplay();
    this.alertService.clearById(this.newuser);
    //this.setCondition(data);
    //console.log(data)
    this.isFormation(data.temps_data);
    data['period'] = this._period;
    this.condition.emit({condition: this.conditionValidationButton, isLoading: this.loading});
    this.ButtonValid = false;
    this.isValid = false;
    this.totalProduction = 0;
    this.totalPlanned = 0;
    this.totalBreak = 0;

    let filterd = [];
    if (data.temps_data.length > 0) {
      this.CrossBlocks(data.temps_data);
      const breaks = data.temps_data.filter(e => ['PLANNED'].indexOf(e.name) > -1)
        .filter(e => e.legend == "PAUSE_INSERVICE");
      const planned = data.temps_data
        .filter(e => ['PLANNED'].indexOf(e.name) > -1).filter(e => ["BRIEF_INSERVICE", "ACTION_INSERVICE"].includes(e.legend));


      let paied = data.temps_data
        .filter(e => {
          const hasSeuil = e.motif && e.motif.code == 'SEUILPLUS';
          const hasSeuilFR = moment(e.end).diff(e.start, 'second') <= BlockTempsComponent.MIN_BLOCK_LENGTH_FR && countryCode == 'FR' && e.motif && (e.motif.code == 'SEUILPLUS' || e.motif.code == 'SEUILMOINS');
          return hasSeuil || hasSeuilFR || ['FULFILLED_INCOHERENCE'].indexOf(e.name) > -1
        });

      // delete tads block from the paid list to exclude it from production calculation
      paied = paied.filter(paie=> paie.legend != "FULFILLED_VALIDATED_INSERVICE_TAD");
      this.hasSeuil = false;
      paied.forEach((d, i) => {
        if(d.justification && ['DEL','CTM','VME','ADM','CSE','ELU','AST','ARH'].includes(d.justification)) {
          filterd.push(d);
        }else {
          if(d.motif && ['SEUILPLUS'].includes(d.motif.code) && d.motif.paied && countryCode && countryCode === 'FR') {
            this.hasSeuil = true;
            filterd.push(d);
          }
          else if (d.type == 'INCOHERENCE') {
            if (d.motif.paied && d.legend != 'EMPTY') {
              filterd.push(d);
            }
          } else {
            filterd.push(d);
          }
        }
      });
      const te = [];
      if (filterd.every(block => block.id)) {
        filterd = _.unique(filterd, x => x.id);
      }
      filterd.forEach((dt, u) => {
        if (moment(dt.end).isAfter(dt.start)) {
          const work = moment(dt.end).diff(moment(dt.start), 'second');
          this.totalProduction += work % 60 == 0 ? work : +work;
          te.push(dt.id);
        }
      });
      console.log('filterd:', filterd, paied);
      planned.forEach((dt) => {
        if (moment(dt.end).isAfter(dt.start)) {
          const pwork = moment(dt.end).diff(moment(dt.start), 'second');
          this.totalPlanned += pwork % 60 == 0 ? pwork : +pwork;
        }
      })

      breaks.forEach((dt) => {
        if (moment(dt.end).isAfter(dt.start)) {
          const pbreak = moment(dt.end).diff(moment(dt.start), 'second');
          this.totalBreak += pbreak % 60 == 0 ? pbreak : +pbreak;
        }
      })
      this.displayAddSystemBlock = this.data.temps_data && this.data.temps_data.every(block => !IS_REALISE_NON_DECLARATIVE(block));
    } else {
      this.displayAddSystemBlock = this.data.temps_data && this.data.temps_data.every(block => !IS_REALISE_NON_DECLARATIVE(block));
    }
    data.productionBlock = filterd;
    data.Display = this.Display;
    data.breaks = (environment.breaks.DURATION.status ?
      this.breakOverflows.filter(d => d.duration >= environment.breaks.DURATION.value) :
      this.breakOverflows);
    data.view = "FULL";
    let toRenderBlock = false;
/*    this.getCountTadHours(data).subscribe(res=>{
      this.allTadHours = res;
      toRenderBlock = true;
      this.renderBlock('app-block-temps .section_' + (typeof version == "undefined" ? 'default' : version)+ '_' + this.newuser, data);
    },error => {
      this.allTadHours = [];
      toRenderBlock = true;
      this.renderBlock('app-block-temps .section_' + (typeof version == "undefined" ? 'default' : version)+ '_' + this.newuser, data);
    })*/

    this.renderBlock('app-block-temps .section_' + (typeof version == "undefined" ? 'default' : version)+ '_' + this.newuser, data);
  }

  async renderBlock(selector: string, data: BlockVO, events?: any, fromDialog?: boolean) {
    d3.select(selector + ' [id*="graph_"]').remove();
    if (events) BLOCKS_EVENT.on = events;
    BLOCKS_EVENT.MOTIFS = this.motifService.motifs
    data.event = BLOCKS_EVENT;

    const collaborator = this.userService.getUser();

    const countryCode: string = collaborator.countryCode;

    // if fromDialog == true not update renderData in this class from dialog ;)
    if (!fromDialog) this.renderData = data;

    this.chart = await visavailChart({
      selector,
      countryCode,
      translations: {
        lang: this.translate.currentLang,
        translate: this.translate.translations[this.translate.currentLang]
      },
      data: data,
      component: this,
      picker: this.picker,
      extras: {
        BLOCK_DATE_FORMAT: countryCode == "FR" ? DATE_BLOCK_FRANCE :  DATE_BLOCK_BASIC
      },
      calendar: {
        maxDate: '',
        minDate: ''
      },
      on: {
        calendar: {
          pickCalendar: () => {

          },
          paginate: () => {

          }
        }
      },
      message: {
        icon: '', title: '', body: [
          "<div>🇫🇷 : Collecte en cours, le traitement des incohérences de cette journée sera accessible dès que possible</div>",
          "<div>🇺🇸 : Collection in progress, the treatment of the inconsistencies of this day will be accessible as soon as possible</div>",
          "<div>🇪🇸 : Cobro en curso, el tratamiento de las inconsistencias de este día será accesible a la mayor brevedad</div>",
          "<div>🇵🇹 : Cobrança em andamento, o tratamento das inconsistências deste dia estará acessível o mais breve possível</div>",
        ], show: this.hasAvailable == false
      },
      allTadHours: this.allTadHours
    })
      .dialog(DialogComponent)
      .callback(this.dialog);
    this._users.forEach((user, i) => {
      let prevuCount = 0;
      if (user.username === this.newuser) {
        data.user = user;
        d3.select('app-block-temps .section_default_' + user.username)
          .datum(data.dataset)
          .call(this.chart);
        if (data.dataset) {
          data.dataset.forEach((d, i) => {
            if (d.caption == this.blockTempsTransalte.BLOCKS.PLANNED) {
              d.data.forEach((o, n) => {
                if (o[1] == 'EMPTY') {
                  prevuCount++;
                }
              });
              this.prevuDisabled = !(prevuCount == d.data.length);
            }
          });

        }
        this.calimDisabled = false;
      }
    });
  }

  setTad(ev: MatCheckbox) {
    this.conditionValidationButton.isLoadTad = false;
    const t = this.data.temps_data; //.filter(e => String(e.tag).toLowerCase() == "planned");
    this.blockservice.updateTad(!ev.checked, t.map(e => e.id).filter(e => e)).subscribe((status: boolean) => {
      },
      error1 => {
        console.log('error:', error1)
      }, () => {
        this.conditionValidationButton.isLoadTad = true;
        this.refresh()
      })

  }
  setShowSeuilPlus(ev: MatCheckbox) {
    this.conditionValidationButton.isShowSeuilPlus = !ev.checked;
    this.blockservice.isShowSeuil = this.conditionValidationButton.isShowSeuilPlus;
    this.refresh();
  }

  checkBlocksTAD(data: any[]) {
    const blocks = [...data].map((d, i) => {
      switch (d.tag.toLowerCase()) {
        case 'planned':
          data[i]['name'] = d.tag.toUpperCase();
          break;
        case 'fulfilled_system':
          data[i]['name'] = d.tag.toUpperCase();
          break;
        case 'fulfilled':
          data[i]['name'] = 'FULFILLED_INCOHERENCE';
          break;
        case 'incoherence':
          data[i]['name'] = 'FULFILLED_INCOHERENCE';
          break;
      }
      return d;
    })
    const planned = blocks.filter(e => String(e.name).toLowerCase() == "planned");
    const fulfilled_system = blocks.filter(e => String(e.name).toLowerCase() == "fulfilled_system");
    const fulfilled_icno = blocks.filter(e => String(e.name).toLowerCase() == "fulfilled_incoherence");
    const isTad = {
      p: (planned.length > 0 && planned.every(e => e.tad == true)), // planned
      r: (fulfilled_system.length > 0 && fulfilled_system.every(e => e.tad == true)), // réalise
      rv: (fulfilled_icno.length > 0 && fulfilled_icno.filter(e => e.tad == true).length > 0), // réalise valide
    }

    this.conditionValidationButton.isTAD = isTad.p || isTad.r || isTad.rv;
  }

  checkBlocksTADV2(data: any[]) {
    const blocks = [...data].map((d, i) => {
      switch (d.tag.toLowerCase()) {
        case 'planned':
          data[i]['name'] = d.tag.toUpperCase();
          break;
        case 'fulfilled_system':
          data[i]['name'] = d.tag.toUpperCase();
          break;
        case 'fulfilled':
          data[i]['name'] = 'FULFILLED_INCOHERENCE';
          break;
        case 'incoherence':
          data[i]['name'] = 'FULFILLED_INCOHERENCE';
          break;
      }
      return d;
    })
    const planned = blocks.filter(e => String(e.name).toLowerCase() == "planned");
    const fulfilled_system = blocks.filter(e => String(e.name).toLowerCase() == "fulfilled_system");
    const fulfilled_icno = blocks.filter(e => String(e.name).toLowerCase() == "fulfilled_incoherence");
    const isTad = {
      p: (planned.length > 0 && planned.every(e => e.tad == true)), // planned
      r: (fulfilled_system.length > 0 && fulfilled_system.every(e => e.tad == true)), // réalise
      rv: (fulfilled_icno.length > 0 && fulfilled_icno.filter(e => e.tad == true).length > 0), // réalise valide
    }

    this.conditionValidationButton.isTAD = isTad.p || isTad.r || isTad.rv;
  }

  addSystemBlock() {
    console.log(1, this.displayAddSystemBlock);
    if (this.displayAddSystemBlock) {
      const dialogRef = this.dialog.open(InsertDialogComponent, {
        width: '600px !important',
        height: '300px !important',
        panelClass: 'InsertDialogComponent',
        data: {
          that: this,
          temps: this.data.temps_data,
          isFormation: this._isFormation,
          user: this.newuser,
          fromAddRealiseValide: true
        }
      });
      dialogRef.afterClosed().subscribe((e) => {
        e ? this.GoToDate('refresh', this.newuser) : '';
      });
    }

  }

  updateRealiseBlock() {
    if (this.isCurrentUser() && !this.conditionValidationButton.isNow) {
      const fulfilled_system = (this.data.temps_data || []).filter(e => e.tag.toLowerCase() == 'fulfilled_system');
      const dialogRef = this.dialog.open(UpdateRealiseDialogComponent, {
        width: '600px !important',
        height: '300px !important',
        panelClass: 'InsertDialogComponent',
        data: {
          that: this,
          temps: fulfilled_system,
          isFormation: this._isFormation,
          user: this.newuser,
          fromAddRealiseValide: true
        }
      });
      console.error('======>', fulfilled_system);
      dialogRef.afterClosed().subscribe((e) => {
        e ? this.GoToDate('refresh', this.newuser) : '';
      });
    } else {
      console.error(this.isCurrentUser() && !this.conditionValidationButton.isNow);
    }

  }

  addRealiseBlock() {
    if (this.displayAddSystemBlock) {
      const blockDeclarative = (this.data.temps_data || []).filter(e => e.tag.toLowerCase() == 'fulfilled_system');
      const breaks = this.data.tmpBreaks;
      const dialogRef = this.dialog.open(InsertRealiseDialogComponent, {
        width: '600px !important',
        height: '300px !important',
        panelClass: 'InsertDialogComponent',
        data: {
          that: this,
          temps: blockDeclarative.map((e) => {
            e.uid = new Date(e.start).getTime();
            e.newMotif = 'REALISE';
            return e;
          }),
          isFormation: this._isFormation,
          user: this.newuser,
          fromAddRealiseValide: true,
          breaks: breaks
        }
      });
      console.error('======>', blockDeclarative);
      dialogRef.afterClosed().subscribe((e) => {
        e ? this.GoToDate('refresh', this.newuser) : '';
      });
    }

  }

  public checkReclamationActionButton() {
    this.incoherences = this.data.temps_data.filter(e => ['FULFILLED_INCOHERENCE'].indexOf(e.name) > -1);
    const isValidatedBy = ((inco: any) => inco.validatedBy);
    const maxValidatedDate = new Date(Math.max.apply([], this.incoherences.filter(inco => inco.validated).map(inco => moment(inco.validated))));
    const formattedMaxValidateDate = moment(maxValidatedDate).format(DATE_TIME_FORMAT);
    const dayAfter = moment(this.blockservice.DateToGMT(Date.now())).add(1, 'days');
    const dayBefore = moment(this.blockservice.DateToGMT(Date.now())).subtract(1, 'days');
    this.reclamButtonEnabled = this.incoherences.every(isValidatedBy)
      && this.isValidDate(maxValidatedDate)
      && moment(formattedMaxValidateDate).isBefore(moment(dayAfter))
      && moment(formattedMaxValidateDate).isAfter(moment(dayBefore));
  }

  public setNow() {
    const d1 = moment(this.valueDate, DATE_DEFAULT_FORMAT).format(DATE_DEFAULT_FORMAT);
    const d2 = moment(new Date(), DATE_DEFAULT_FORMAT).format(DATE_DEFAULT_FORMAT);
    this._isNow = moment(d1).isSame(d2);
    return moment(d1).isSame(d2);
  }

  public isValidDate(d) {
    return d instanceof Date && !isNaN(Number(d));
  }

  public setCondition(data) {
    this.conditionValidationButton.isNow = (this.router.url == '/checksum' ? false : this.setNow());
    let FULFILLED_INCOHERENCE = data.temps_data.filter(e => 'FULFILLED_INCOHERENCE' == e.name.toUpperCase());
    let FULFILLED_SYSTEM = data.temps_data.filter(e => e.tag.toLowerCase() == 'fulfilled_system');

    this.conditionValidationButton.isFULFILLED_INCOHERENCE = (FULFILLED_INCOHERENCE.length > 0);
    if (this.Display.buttons.valider && FULFILLED_INCOHERENCE.length > 0) {
      if (FULFILLED_INCOHERENCE.length == 0) {
        this.conditionValidationButton.isNow = true;
      }
      let inco = FULFILLED_INCOHERENCE;
      let count_validated = 0;
      // check all blocks is validated without user SYSTEM
      const min_block_length_filter = e => moment(e.end).diff(e.start, 'second') > BlockTempsComponent.MIN_BLOCK_LENGTH && (e.validatedBy && e.validatedBy.username != "system");
      const all_block_length_filter = e => moment(e.end).diff(e.start, 'second') > BlockTempsComponent.MIN_BLOCK_LENGTH;
      this.incos = []
      inco.forEach(e => {
        if (e.validatedBy && min_block_length_filter(e)) {
          {
            count_validated++;
            this.incos.push(e);
          }
        }
      });
      const filteredFulFilledIncoherenceList: any[] = FULFILLED_INCOHERENCE.filter(all_block_length_filter);
      let validatedFulfilledIncoherenceNb: number = 0;
      let breaks = _.pluck(this.breakOverflows, 'updatedBy').filter(this.onlyUnique).filter(e => e !== null);
      const filtered_incoherences = inco.filter(min_block_length_filter);
      const allBlocks = inco.filter(all_block_length_filter);
      const validated_blocks_filter = e => e.validatedBy;
      let validatedFulfilledIncoherenceList: any[] = FULFILLED_INCOHERENCE.filter(validated_blocks_filter).filter(all_block_length_filter)
      if (validatedFulfilledIncoherenceList.length > 0) {
        validatedFulfilledIncoherenceNb = validatedFulfilledIncoherenceList.length
      }
      if (filtered_incoherences.length > 0) {
        this.conditionValidationButton.isValidateFULFILLED_INCOHERENCE = (allBlocks.length === 1 && count_validated === 1) || (filteredFulFilledIncoherenceList.length == validatedFulfilledIncoherenceNb);
        this.conditionValidationButton.validationDate = this.conditionValidationButton.isValidateFULFILLED_INCOHERENCE ?
          moment(filtered_incoherences[0].validated).add(this.tzService.tz, 'hours').toDate() : null;
      }
      this.conditionValidationButton.isValidateBreaks = (breaks.length > 0 && breaks.indexOf(null) < 0);
      const _validateBy = _.pluck(inco, 'validatedBy').filter(this.onlyUnique).filter(e => e !== null);
      if (_validateBy.length > 0) {
        this.validatedBy = _validateBy[0];
      }
      /**
       * Vérification is Fulfilled system
       * */
      this.conditionValidationButton.hasBlockFULFILLED_SYSTEM = FULFILLED_SYSTEM.length > 0;
    }
    // @Check Blocks has TAD
    this.checkBlocksTAD(data.temps_data)

  }

  public ChangeDate(type: string, event: MatDatepickerInputEvent<Date>) {
    this.blockservice.saveData[this.newuser] = this.blockservice.saveData[this.newuser] || {date: null} // #rf_code
    this.blockservice.saveData[this.newuser].date = moment(event.value, DATE_TIMEZONE_FORMAT).toDate();
    this.GoToDate('refresh', this.newuser);
  }

  async GoToDate(action?: string, usernameL?: string, toDate?,fromSave?:boolean) {
    const translate = this.translate.translations[this.translate.currentLang];
    this._isNow = true;
    this.newuser = usernameL;
    this.loading = true;
    this.onLoad && this.onLoad.emit(true);
    let newdate = null;
    this.durationBreak = 0;
    this.messageService.getMessage().subscribe(res => {
      this.blockNavigation = res;
    });
    if (!fromSave) this.isShowBtnUpdateRealise = true;
    if (action == "goto") {
      console.log('toDate:', toDate)
    }

    if (action === 'refresh' && this.data) {
      const user = this.blockservice.saveData[usernameL];
      if(user && user.date) {
        newdate = moment(this.blockservice.saveData[usernameL].date).add(Action[action], 'days').format(DATE_DEFAULT_FORMAT);
      }
    } else {
      newdate = moment(moment()).add(Action[action], 'days').format(DATE_DEFAULT_FORMAT);
    }
    if (action !== 'now' && this.data && action && this.blockservice.saveData[usernameL]) {
      const currentdate = this.blockservice.saveData[usernameL].date;
      newdate = moment(currentdate).add(Action[action], 'days').format(DATE_DEFAULT_FORMAT);
    }

    if (action === 'goto') {
      /* force date first time to J-1 */
      if (moment(toDate).format(DATE_DEFAULT_FORMAT) == moment().format(DATE_DEFAULT_FORMAT) && action == "goto") {
        newdate = moment(toDate).subtract(1, 'd').format(DATE_DEFAULT_FORMAT);
      } else {
        newdate = moment(toDate).format(DATE_DEFAULT_FORMAT);
      }
    }
    if (action == "goto") {
      console.log('toDatex:', toDate)
    }


    if (this.router.url == '/checksum') {
      const currentdate = moment(new Date());
      newdate = moment(currentdate).add(Action['checksum'], 'days').format(DATE_DEFAULT_FORMAT);
      this.conditionValidationButton.isNow = false;
      this.Display.paginator = false;
    }

    this.valueDate = newdate.toString()

    // check date block is equals now
    this.conditionValidationButton.isNow = this._isNow = moment(newdate).format(DATE_DEFAULT_FORMAT) == moment().format(DATE_DEFAULT_FORMAT);

    console.log('valueDate:', newdate)

    this.blockDate.emit(moment(newdate.toString()).format(DATE_DEFAULT_FORMAT));

    if (typeof usernameL !== 'undefined') {
      this._users[0].date = moment(this.valueDate.toString()).toDate();
      this.initCondition();
      localStorage.setItem('date_' + usernameL, moment(newdate).format(DATE_DEFAULT_FORMAT));
      this.checkVerro(() => {
        this.auth.getDetailsUser(usernameL).then((details) => {
          this.detailsCollaborator = details;
          this.blockservice.availableBlock(newdate, usernameL).subscribe((hasAvailable: boolean) => {
            this.hasAvailable = hasAvailable;
            this.blockservice.getTimeZoneFromReferentiel(usernameL, this._users[0].villeLabel, newdate, () => {
              this.breakService.getBreakOverflows(usernameL, moment(newdate).format(DATE_DEFAULT_FORMAT), hasAvailable).subscribe(breakOverflows => {
                if (breakOverflows instanceof Array) {
                  this.breakOverflows = breakOverflows;
                  this.getCountTadHours(usernameL, moment(newdate).format(DATE_DEFAULT_FORMAT)).subscribe((blocksTad: any) => {
                    this.blockservice.load(hasAvailable,
                      usernameL,
                      moment(newdate).format(DATE_DEFAULT_FORMAT),
                      async (data) => {
                        this.blockservice.saveData[usernameL].date = moment(newdate, DATE_DEFAULT_FORMAT).toDate();
                        this.data = data;
                        data.user._username = usernameL;
                        //this.setCondition(data);
                        this.valueDate = newdate.toString();
                        if (MAURICE_MATRICULE_TEST.includes(usernameL)) {
                          await this.correctBreakOverflowProcess(usernameL, data);
                        } else {
                          this.setBlock(data);
                        }
                        this.setCondition(data);
                        this._users[0]['currentDate'] = newdate.toString();
                        if (localStorage.getItem('divBlock') == '0') {
                          window['root']['data'] = data;
                        }

                        this.paginationButtons = true;
                        setTimeout(() => {
                          this.loading = false;
                          this.onLoad && this.onLoad.emit(false);
                          if (this.router.url == '/searchtimesheet') {
                            // View DSI disable modification
                            this.conditionValidationButton.isNow = true;
                            this._isNow = true;
                          }
                          this.condition.emit({condition: this.conditionValidationButton, isLoading: this.loading});

                        }, 200);
                      },
                      breakOverflows, blocksTad)
                  });
                }
                // @MAURICE TEMP PROCESS TO DELETE LATER
                if (!usernameL.startsWith('R') || moment(this.blockservice.currentDate).isBefore(environment.mauriceNewBreakApiStartDate)) {
                  race(
                    this.breakService.getBreak(usernameL, (typeof newdate != 'undefined' ? newdate : this.valueDate)),
                    timer(MAX_WAIT_TIME_IN_MS).map(rs => TIMER_INDICATOR))
                    .subscribe((data: any) => {
                      if (Object.keys(data).length > 0) {
                        this.durationBreak = data.duration;
                      }
                      if (data == TIMER_INDICATOR) {
                        this.alertService.error('La requête a pris trop de temps pour répondre. Merci de rafraichir la page ', this.newuser);
                      }
                      this.messageService.clearMessages();
                    });
                } else {
                  race(this.blockservice.getThreeDaysBlocksAndBreaks(usernameL, (typeof newdate != 'undefined' ? newdate : this.valueDate)),
                    timer(MAX_WAIT_TIME_IN_MS).map(ts => [TIMER_INDICATOR]))
                    .subscribe((data: any) => {
                        if (data[0] == TIMER_INDICATOR) {
                          this.alertService.error('La requête a pris trop de temps pour répondre. Merci de rafraichir la page ', this.newuser);
                        } else {
                          data = data.flatMap((rs: any) => rs.breakVOS);
                          const totalBreak = this.getTotalBreak(data);
                          this.durationBreak = !totalBreak || Number.isNaN(totalBreak) ? 0 : totalBreak;
                        }
                        this.messageService.clearMessages();
                      },
                      error => this.LOG.warn(`Error accured while getting breaks details `));
                }
                // Get comment fiche
                this.getComment(newdate);

              });
            });
          })
        })
      })
    }
  }

  getTotalBreak(breaks) {
    const {_dayoffStartInterval, _dayoffEndInterval} = this.blockservice.getIntervalOfCountry();
    const allowedBreaks = b => b.start && b.end && moment(this.tzService.GmtToLocale(b.start)).isBetween(_dayoffStartInterval, _dayoffEndInterval) && moment(this.tzService.GmtToLocale(b.end)).isBetween(_dayoffStartInterval, _dayoffEndInterval);
    if (Object.keys(breaks).length > 0) {
      return breaks
        .filter(allowedBreaks)
        .map(b => b && b.duration)
        .reduce((sum, current) => sum + current, 0);
    }
  }

  correctBreakOverflowProcess = async (usernameL, data) => {
    let breakOverflowIsCorrect = false;
    const blocks = [...this.blockservice.saveData[usernameL].data];
    const breaks = [...this.blockservice.saveData[usernameL].breaks];
    const {_dayoffStartInterval, _dayoffEndInterval} = this.blockservice.getIntervalOfCountry();
    await this.blockservice.getThreeDaysBlocksAndBreaks(usernameL, this.blockservice.currentDate).toPromise().then(async (res: any) => {
        if (res) {
          res = res.flatMap((rs: any) => rs.breakVOS);
          const totalBreak = this.getTotalBreak(res);
          this.durationBreak = !totalBreak || Number.isNaN(totalBreak) ? 0 : totalBreak;
          const theoriquePause = this.totalPauses(blocks, IS_PLANNED_PAUSE, PLANNED_PAUSE_DURATION);
          const overflow = breaks && breaks.filter($DURATION).map($DURATION).reduce((sum, current) => sum + current, 0);
          breakOverflowIsCorrect = this.checkResendBreakOverflowAPI(theoriquePause, this.durationBreak, overflow);
          this.LOG.info(`Planned pauses = [${theoriquePause}], totalPauses = [${this.durationBreak}], Overflow = [${overflow}], Send New Overflow API ? [${!breakOverflowIsCorrect}]`);
          if (!breakOverflowIsCorrect) {
            this.breakService.getCrossBreak(usernameL, moment(this.valueDate).format(DATE_DEFAULT_FORMAT), this.toGMTIsoDate(_dayoffStartInterval), this.toGMTIsoDate(_dayoffEndInterval)).toPromise().then(res => {
              if (res) {
                data.breaks = [res];
                this.breakOverflows.push(res);
                this.setBlock(data);
              } else {
                this.setBlock(data);
              }
              this.LOG.info('Break Overflow needs to be recalculated !');
            });
          } else {
            this.LOG.info(`Normal Break Overflow `);
            data.breaks = (environment.breaks.DURATION.status ?
              this.breakOverflows.filter(d => d.duration >= environment.breaks.DURATION.value) :
              this.breakOverflows);
            this.setBlock(data);
          }
        } else {
          this.setBlock(data);
        }

      }
    );

  };

  toGMTIsoDate = (date) => moment(this.tzService.LocaleToGmt(date)).add(Math.abs(new Date().getTimezoneOffset()), 'minutes').toISOString();

  checkResendBreakOverflowAPI = (plannedPauses, realPauses, overflow) => +plannedPauses + overflow >= +realPauses;

  totalPauses = (blocks, pauseFilter, pauseDurationMapper) => {
    if (!isNumber(blocks)) {
      return blocks
        .filter(pauseFilter)
        .map(pauseDurationMapper)
        .reduce((sum, current) => sum + current, 0);
    }
    return blocks;
  };

  public zoom(username, action) {
    switch (action) {
      case 'out':
        this.width -= (this.width > this.oldWidth ? 1000 : 0);
        break;
      case 'in':
        this.width += (this.width < this.oldWidth ? 0 : 1000);
        break;
      case 'reset':
        this.width = this.oldWidth;
        break;
    }
    //  // console.log(this.blockservice.refreshData, username)
    this.setBlock(this.blockservice.refreshData[username]);
  }

  public Calim(user) {
    this.blockservice.currentUser = {
      user: user,
      date: this.valueDate,
      breakOverflows: this.breakOverflows,
      incoherences: this.incoherences
    };
    // this.router.navigateByUrl('/reclamation');
    this.dialog.open(ReclamationDialogComponent, {
      width: '340px',
      data: {
        user: this.blockservice.currentUser
      }
    });

  }

  public Valider(user, el) {
    if (this._isFormation) {
      if (!this.conditionValidationButton.isValidateBreaks && this.breakOverflows.length > 0) {
        const translate = this.translate.translations[this.translate.currentLang];
        this.alertService.error(translate.MSG_REQUIERD_BREAK, this.newuser);
        setTimeout(() => {
          el.checked = false;
        }, 50);
      } else {
        const dialogRef = this.dialog.open(ConfirmatonDialogComponent, {
          width: '300px !important',
          height: '100px !important',
          panelClass: 'ConfirmationDialog',
          data: {
            hoursOfProd: (this.totalProduction / 60 / 60),
            blockIds: this.blockservice.saveData[user].data.filter(
              e => e.id && ['INCOHERENCE', 'FULFILLED'].indexOf(e.tag.toUpperCase()) > -1
            ).map(e => e.id),
            breakOverflowIds: this.breakOverflows.map(e => e.id),
            breakOverflowDurations: this.breakOverflows.map(e => e.duration),
            dateShift: this.blockservice.currentDate
          }
        });
        dialogRef.afterClosed().subscribe((e) => {
          if (e) this.isShowBtnUpdateRealise = false;
          this.GoToDate('refresh', this.newuser,null,true);
        });
      }
    } else {
      this.alertService.info('L\'agent est programmé dans une session de formation sur cette période. ' +
        'La validation de ses heures de travail est à la charge de l\'animateur de la formation.', this.newuser);
      setTimeout(() => {
        el.checked = false;
      }, 50);
    }
  }

  /* Check Source Block */
  hasRealiseSource(s: string) {
    const blockDeclarative: Array<any> = (this.data.temps_data || []).filter(e => e.tag.toLowerCase() == 'fulfilled_system');
    const isDeclarative = e => e.source === 'DECLARATIVE';
    const isNotDeclarative = e => e.source !== 'DECLARATIVE';
    return blockDeclarative.every(s === 'ANY' ? isNotDeclarative : isDeclarative);
  }

  isCurrentUser() {
    const emptyUser = this._users[0].username !== this.userService.getCurrentUser('userName');
    return emptyUser || this.conditionValidationButton.isValidateFULFILLED_INCOHERENCE;
  }

  regenerate() {
    if (!this._regLoading && !this.prevuDisabled && !this.conditionValidationButton.isValidateFULFILLED_INCOHERENCE) {
      const {authorities} = JSON.parse(localStorage.getItem(environment.oauth.remoteUser));
      const role = authorities.filter(e => e.clientId == 'myshift2').map(e => e.authority);
      const isfor = (role.indexOf(ROLE_FORMATEUR_MYSHIFT2) > -1 || role.indexOf(ROLE_COORDI_FORMATION_MYSHIFT2) > -1);
      const translate = this.translate.translations[this.translate.currentLang];
      const message = (isfor ? translate.MSG_COACH : translate.MSG_PPV);
      if (this.valueDate != null) {
        this._regLoading = true;
        this.blockservice.getPlanned(this.newuser, moment(this.valueDate).format(DATE_DEFAULT_FORMAT)).subscribe(value => {
          if (!value) {
            this.alertService.error(message, this.newuser);
          } else {
            this.GoToDate('refresh', this.newuser);
          }
        }, error => {
          this.alertService.error(translate.MSG_PPV, this.newuser);
          this._regLoading = false;
        }, () => {
          setTimeout(() => this._regLoading = false, 250);
        });
      }
    }
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  onlyUniqueObj(array) {
    const result = [];
    const map = new Map();
    for (const item of array) {
      if (!map.has(item.id)) {
        map.set(item.id, true);    // set any value to Map
        result.push({
          id: item.id,
          name: item.name
        });
      }
    }
    return result;
  }

  refresh() {
    this.GoToDate('refresh', this.newuser);
    if (!this.commentFiche || (this.commentFiche && !this.commentFiche.id))
      this.isShowComment = true;
  }

  openBlock(newuser:any, isUnlockFiche?: boolean) {
    console.log('newuser', newuser);
    const dialogRef = this.dialog.open(ReclamationDialogComponent, {
      width: '300px !important',
      height: '100px !important',
      panelClass: 'ReclamationDialog',
      data: {
        user: newuser,
        isUnlockFiche: isUnlockFiche,
        blockIds: this.blockservice.saveData[newuser].data.filter(
          e => e.id && ['INCOHERENCE', 'FULFILLED'].indexOf(e.tag.toUpperCase()) > -1
        ).map(e => e.id),
        breakOverflowIds: this.breakOverflows.map(e => e.id),
        breakOverflowDurations: this.breakOverflows.map(e => e.duration),
        dateShift: moment(this.blockservice.currentDate).format(DATE_DEFAULT_FORMAT)
      }
    });
    dialogRef.afterClosed().subscribe((e) => {
      e ? this.GoToDate('refresh', this.newuser) : '';
    });
  }

  isBetween(_date, _start, _end) {
    if (_start != null && !_end != null) {
      const date = moment(_date);
      const isNext = date.isSameOrBefore(moment(_end));
      const isPrev = date.isSameOrAfter(moment(_start));
      return (isNext && isPrev);
    } else {
      return true;
    }
  }

  isFormation(data) {
    const {authorities} = JSON.parse(localStorage.getItem(environment.oauth.remoteUser));
    const role = authorities.filter(e => e.clientId == 'myshift2').map(e => e.authority);
    let d = (typeof data == 'undefined' ? [{}] : data.filter(e => e.tag.toLowerCase() == 'planned'));
    let f = d.map((e) => {
      if (Object.keys(e).indexOf('label')) {
        return e.label;
      }
    });
    this._isFormation = (f[0] == 'FORMATION');
    const roleFormateur = (role.indexOf(ROLE_FORMATEUR_MYSHIFT2) > -1) || (role.indexOf(ROLE_COORDI_FORMATION_MYSHIFT2) > -1);
    // OLD LINE
    this._isFormation = (this._isFormation ? roleFormateur : true);

    // NEW LINE
    return this.isFormation;
  }


  BreakDuration(duration: string) {
    let sec_num: any = parseInt(duration, 10); // don't forget the second param
    let hours: any = Math.floor(sec_num / 3600);
    let minutes: any = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds: any = sec_num - (hours * 3600) - (minutes * 60);

    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    return hours + ':' + minutes + ':' + seconds;
  }

  public CrossBlocks(data) {
    data = data.filter(e => e.name != 'FULFILLED_INCOHERENCE');
    /*// console.log('Blocks', data)*/
    let dates = [];
    data = _.sortBy(data, 'start');
    let i = 0;
    for (i = 0; i < data.length; i++) {
      if (data[i].label !== 'Pause' || typeof data[i].label == 'undefined') {
        dates.push(data[i].start);
        if (typeof data[i].end == 'undefined') {
          break;
        }
        dates.push(data[i].end);
      }
    }

    dates = _.unique(dates);
    dates = _.sortBy(dates);

// chunck array
    dates = dates.map((e, i) => {
      return [e, dates[i + 1]];
    });
    dates = dates.slice(0, dates.length - 1);
  }

  /**
   * Check Condition of buttons
   * @type: [
   *    UPDATE_BLOCK_REALISE,
   *    SET_BLOCK_DECLARATIVE
   * ]
   * */
  public checkCondition(type: string): boolean {
    let condition = false;
    const collaborator = this.userService.getUser();
    const countryCode: string = collaborator.countryCode;

    let user = this.userService.getCurrentUser('userName');
    switch (type) {
      case 'SHOW_BTN_VALIDATION' : {
        /** show btn valider si les FULFILLED_INCOHERENCE = Fullfilled or INCOHERENCE > 0*/
        const incos = this.data.temps_data.filter(e => 'FULFILLED_INCOHERENCE' == e.name.toUpperCase())
        this.conditionValidationButton.isValidateFULFILLED_INCOHERENCE = this.checkIsBlocksInDisplayFiche();
        condition = this.conditionValidationButton.isValidateFULFILLED_INCOHERENCE ?
          incos.length > 0 && !this.checkIsDayOffAndAllBlocksTimeInsertionType(incos): incos.length > 0 && !this.conditionValidationButton.enableVerroButton && !this.checkIsDayOffAndAllBlocksTimeInsertionType(incos);
      } ;
        break;
      case 'UPDATE_BLOCK_REALISE' : {
        condition = this.hasRealiseSource('ANY') && this.conditionValidationButton.hasBlockFULFILLED_SYSTEM &&
          this.isCurrentUser() &&
          !this.conditionValidationButton.isValidateFULFILLED_INCOHERENCE &&
          !this.conditionValidationButton.isNow && !this.conditionValidationButton.enableVerroButton;
      }; break;
      case 'SET_BLOCK_DECLARATIVE' : {
        condition = environment.exceptionUserInjectRealise.includes(user) &&
          (!this.conditionValidationButton.isValidateFULFILLED_INCOHERENCE && this.isCurrentUser() && !this.conditionValidationButton.isNow
            && this.displayAddSystemBlock);
      }; break;
      case 'CHECK_BLOCKS_HAS_NOEMPTY_OF_FRANCE': {
        const payload = (this.data.temps_data || []);
        condition =
          payload.length > 0 && countryCode && countryCode === 'FR';
      }; break;
      case 'CHECK_BLOCKS_HAS_NOEMPTY': {
        const payload = (this.data.temps_data || []);
        condition = payload.length > 0
      }; break;
      case 'CHECK_BLOCKS_REALIZED_AND_PAID': {
        const uo = this.detailsCollaborator ? this.detailsCollaborator.uo : "";
        const payload = JSON.parse(JSON.stringify((this.data.temps_data || [])));
        const realized = payload.filter(e => e.name == "FULFILLED_INCOHERENCE" && (!e.motif || (e.motif && (e.motif.paied || (!e.motif.paied && e.legend == 'INSERVICE')))));
        condition = (payload.length > 0 && realized.length > 0) && this.isCurrentUser() &&
          !this.conditionValidationButton.isNow && ((countryCode && countryCode === 'FR') || (String(uo).toLowerCase().includes("ma-intownprod-daxon as")));
      }; break;
      case 'CHECK_SHOW_TAD': {
        const payload = (this.data.temps_data || []);
        condition =
          payload.length > 0 && countryCode && countryCode === 'FR' && this.checkCaseShowTad(payload);
      };break;
    }
    return condition;
  }

  OpenMutualisation() {
    const mutualisation = this.dialog.open(MutualisationDialogComponent, {
      width: 'calc(100vw - 220px)',
      maxWidth: 'calc(100vw - 220px)',
      data: {
        data: {
          renderData: {...this.renderData},
          componentBlockTemps: this
        }
      }
    })
    mutualisation.afterClosed().subscribe(() => {
      this.GoToDate('refresh', this.newuser);
    });
  }

  loadBlockVersion(response: any) {
    this.blockservice.loadByData(response, this.newuser,
      moment(this.valueDate).format(DATE_DEFAULT_FORMAT), (data) => {
      this.setBlock(data, undefined)
      }, null
    )
  }
  checkCaseShowTad(payload) {
    let condition = true;
    if ( payload && payload.length > 0 ) {
      let fullfilled = payload.filter(b => b.blockStatus === 'PROCESSED' );
      let allPlanned = payload.filter(b => b.type === 'PLANNED' );
      let conges = allPlanned && allPlanned.length > 0 ? allPlanned.filter( b => b.source === 'MyConges') : [];
      if ( conges.length > 0 ) {
        let startConge = conges[0].start;
        let endConge = conges[0].end;
        let halfDay = Math.abs(moment(startConge).diff(endConge, 'hours')) < 13;
        if( !halfDay ){
          if( fullfilled.length >= 0 ){
            condition = false;
          }
        } else {
          if( fullfilled.length == 0 ){
            condition = false;
          }
        }
      }
      let dayOff = allPlanned.filter(b => b.label === 'Off');
      if( dayOff && dayOff.length > 0 && fullfilled.length >= 0) {
        condition = false;
      }
    }
    return condition;
  }
  get hasCountry() {
    const collaborator = this.userService.getUser();
    const countryCode: string = collaborator.countryCode;
    return countryCode;
  }

  get getIncos() {
    const incos: any = (this.data.temps_data || []).filter(e =>
      (e.type == 'INCOHERENCE' && e.motif && e.motif.code != "SEUILPLUS" && !JUSTIFICATION_TIME_INSERT.includes(e.justification?e.justification:"") && !this.hasSeuilFRMoinsMinute(e)))
    return incos;
  }
  openDialogInco() {
    const [firstInco] = this.getIncos;
    if(firstInco) {
      this.chart.showDialogIcons(['INCOHERENCE', 'INCOHERENCE_CREATED_INSERVICE']);
    }
  }

  private getCountTadHours(username:any, date:any) {
    let filter: TadInHoursFilter = new TadInHoursFilter();
    filter.deleted = false;
    filter.dateStart =date;
    filter.dateEnd =date;
    //let date :any = moment(data.user.date).format('YYYY-MM-DD');
    //filter.createdBy = JSON.parse(localStorage.getItem(environment.oauth.remoteUser)).userName;
    filter.registrationNumber = username;
    return this.serviceApi.getAllTadHours(filter);
  }

  checkIsBlocksInDisplayFiche() {
    if (this.conditionValidationButton.isValidateFULFILLED_INCOHERENCE)  return this.conditionValidationButton.isValidateFULFILLED_INCOHERENCE;
    let elements = this.elRef.nativeElement.querySelectorAll(".axis");
    let dataset = elements[0].__data__;
    let dates = this.getDates(dataset);

    let validate = this.incos.filter(inc => inc.id != -1 && moment(inc.start).isSameOrAfter(dates[0]) && moment(inc.end).isSameOrBefore(dates[1]))

    this.conditionValidationButton.isValidateFULFILLED_INCOHERENCE = validate.length>=2
    return this.conditionValidationButton.isValidateFULFILLED_INCOHERENCE;
  }

  private getDates(dataset: any) {
    let startDate;
    let endDate;

    dataset.forEach(function (series, seriesI) {
      if (seriesI === 0) {
        startDate = series.disp_data[0] && series.disp_data[0][0];
        endDate = series.disp_data[series.disp_data.length - 1] && series.disp_data[series.disp_data.length - 1][2];
      } else {
        if (series.disp_data[0] && series.disp_data[0][0] < startDate) {
          startDate = series.data[0][0], -1;
        }
        if (series.disp_data[series.disp_data.length - 1] && series.disp_data[series.disp_data.length - 1][2] > endDate) {
          endDate = series.disp_data[series.disp_data.length - 1] && series.disp_data[series.disp_data.length - 1][2];
        }
      }
    });

    if(!startDate && !endDate) {
      const dates = dataset.map(e => e.data.map(e => e[0]).flat()).flat();
      startDate=new Date(Math.min.apply(null,dates));
      endDate=new Date(Math.max.apply(null,dates));
    }

    return [moment(startDate).format(DATE_TIME_FORMAT), moment(endDate).format(DATE_TIME_FORMAT)];
  }

  checkCountryAllowedForUnlocking(){
    return this.userService.checkIfCountryAuthorizedForUnlocking(false) && !this.conditionValidationButton.isValidateFULFILLED_INCOHERENCE && !this.isHorsProd();
  }
  isHorsProd() {
    return this.userService.isHorsProdMyShift();
  }

  private checkIsDayOffAndAllBlocksTimeInsertionType(incos:any[]) {
    return this.blockservice.isDayOFF && incos.filter(inc=> inc.justification && JUSTIFICATION_TIME_INSERT.includes(inc.justification)).length == incos.length;
  }
  openDialogComment() {
    const dialogRef = this.dialog.open(ModalCommentComponent, {
      data: {
          commentFiche: this.commentFiche,
          user: this._users[0].username,
          dateShift:  moment(this.blockservice.currentDate).format(DATE_DEFAULT_FORMAT),
          isValid : this.conditionValidationButton.isValidateFULFILLED_INCOHERENCE
      },
      width: '600 !important',
      height: '560px !important',
      panelClass: 'cdk-modal-comment',
    });
    dialogRef.afterClosed().subscribe(e=> {
      if(e){
        this.refresh();
      }
    });
    if (!this.isShowComment && this.commentFiche && this.commentFiche.id)
      this.userShowComment();
  }
  private hasSeuilFRMoinsMinute(e: any) {
    let countryCode =  this.userService.getUserCountry();
    return e.end && e.start && moment(e.end).diff(e.start, 'second') <= BlockTempsComponent.MIN_BLOCK_LENGTH_FR && countryCode == 'FR' && e.motif && (e.motif.code == 'SEUILPLUS' || e.motif.code == 'SEUILMOINS');
  }

  checkIfUserFromTheOMICompany() {
    return this.userService.checkIfUserFromTheOMICompany();
  }

  private getComment(newdate) {
    let dateShift = moment(newdate).format(DATE_DEFAULT_FORMAT);
    let user = this._users[0].username;
    this.blockservice.getCommentFiche(dateShift, user, 'FICHE')
      .subscribe(res => {
        if (res && res.length > 0) {
          this.commentFiche = res[0];
          if (this.commentFiche && this.commentFiche.addedBy && this.commentFiche.addedBy.username == this.userService.getCurrentUser('userName'))
            this.isShowComment = true;
          this.checkUserShowComment();
        }else this.isShowComment = true;
      });
  }

  private checkUserShowComment(){
    let currentUser = this.userService.getCurrentUser('userName');
    let idComment = this.commentFiche.id;
    this.blockservice.checkUserShowComment(currentUser,idComment)
      .subscribe(res=> {
        this.isShowComment = res;
        console.log("res : ",res);
      })

  }

  private userShowComment(){
    let currentUser = this.userService.getCurrentUser('userName');
    let idComment = this.commentFiche.id;
    this.blockservice.userShowComment(currentUser,idComment)
      .subscribe(res=> {
        console.log("res : ",res);
        this.isShowComment = true;
      })
  }

  isShowC(){
    if (this.commentFiche && this.commentFiche.addedBy &&  this.commentFiche.addedBy.username === this.userService.getCurrentUser('userName')) return true;
    return this.isShowComment?this.isShowComment: !this.commentFiche || (this.commentFiche && !this.commentFiche.id);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/block-temps/block-temps.component.ts